import { styled } from "@mui/material/styles";

const StyledStepper = styled("div")(
  ({ theme }) => `
  .MuiStep-root {
    text-align: center;
  }

  .css-17tqrqj-MuiTypography-root{
    font-size: 12px !important;
  }

.MuiStepLabel-label {
  font-family: Lexend !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  font-style: normal !important;
  line-height: 15px !important;
  color: ${theme.palette.customColor.secondarySecond} !important;
  margin-top: 4px !important;
}
.label-text {
  font-family: Lexend !important;
  font-weight: 400 !important;
  font-size: 12px !important;
  font-style: normal !important;
  line-height: 15px !important;
  color: ${theme.palette.customColor.secondarySecond} !important;
  margin-top: 4px !important;
}  

@media screen and (max-width: 480px) {
  .MuiStepLabel-label {
    font-size: 10px !important;
    line-height: 12.5px !important;
  }
  .label-text {
        font-size: 10px !important;
        line-height: 12.5px !important;
  } 
}
 .MuiStepLabel-label.Mui-active {
   color: ${theme.palette.primary.main} !important;
  } 
 .MuiStepLabel-label.Mui-completed {
   color: ${theme.palette.primary.main} !important;
  } 

  .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel {
     margin-top: 4px;
  }

  .MuiStepIcon-root {
    border: 1px solid ${theme.palette.customColor.secondaryThird};
    background-color: white;
    color:${theme.palette.customColor.secondarySecond};
    border-radius: 0;
    font-size: 20px;
    width: 34px;
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 480px) {
      width: 23.71px;
      height: 23.71px;
    }
  }

  .MuiStepIcon-root svg, 
  .MuiStepIcon-root circle {
    display: none;
  }

  .MuiStepIcon-root.Mui-active {
    border: 1px solid #A78D78;
    background-color: #A78D78;
    color: white;
  }

    .MuiStepIcon-root.Mui-completed {
    background-color: #A78D78;
    border: 1px solid #A78D78;
    }

  .MuiStepConnector-line {
    border-color: ${theme.palette.customColor.secondaryThird};;
    border-top-width: 2px;
    margin: 6px 6px;

    @media screen and (max-width: 480px) {
      margin-top: 0px;
    }
  }

    .MuiStepIcon-root.Mui-active .MuiStepIcon-text {
    fill: white;
  }
`
);

export default StyledStepper;

export const StyledSepperSteps = styled("div")(({ theme }) => ({
  ".not-active-step": {
    border: `1px solid ${theme.palette.customColor.secondaryThird}`,
    backgroundColor: "white",
    color: `${theme.palette.customColor.secondarySecond}`,
    borderRadius: "0",
    width: "34px",
    height: "34px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Lexend",
    fontWeight: "400",
    fontSize: "14px",
    fontStyle: "normal",
    lineHeight: "17.5px",
    "@media screen and (max-width: 480px)": {
      fontSize: "9.76px",
      lineHeight: "12.2px",
    },
  },
  ".active-step": {
    border: `1px solid ${theme.palette.secondary.main}`,
    backgroundColor:`${theme.palette.secondary.main}`,
    color: `${theme.palette.customColor.white}`,
    borderRadius: "0",
    width: "34px",
    height: "34px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Lexend",
    fontWeight: "400",
    fontSize: "14px",
    fontStyle: "normal",
    lineHeight: "17.5px",
    "@media screen and (max-width: 480px)": {
      fontSize: "9.76px",
      lineHeight: "12.2px",
    },
  },
  ".completed": {
    backgroundColor: "#A78D78",
    color: "white",
    borderRadius: "0",
    fontSize: "20px",
    width: "34px",
    height: "34px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));
